//v1
//const URL_BASE = "https://ms75utuwu0.execute-api.sa-east-1.amazonaws.com/prd"; // versao antiga Produção
//v2 teste, deu certo, voltou para v1
//const URL_BASE = "https://6g5zcd8hq7.execute-api.sa-east-1.amazonaws.com/prd"; // nova versao Produção
//const URL_BASE = "http://localhost:3000/prd";

//const URL_BASE_AUTENTICACAO = "http://localhost:3000/prd";
const URL_BASE_AUTENTICACAO = "https://60jwbd1p90.execute-api.sa-east-1.amazonaws.com/prd";

//const URL_BASE_ONBOARDING = "http://localhost:3000/prd";
const URL_BASE_ONBOARDING = "https://gztdg3yvfj.execute-api.sa-east-1.amazonaws.com/prd";

//const URL_BASE_CORE = "http://localhost:3000/prd";
const URL_BASE_CORE = "https://a1mul09wfe.execute-api.sa-east-1.amazonaws.com/prd";

//const URL_BASE_PEDIDOS = "http://localhost:3019/prd";
const URL_BASE_PEDIDOS = "https://mckdigx6ve.execute-api.sa-east-1.amazonaws.com/prd";

//const URL_BASE_PROJETOS = "http://localhost:3000/prd";
const URL_BASE_PROJETOS = "https://w2r8fwv7df.execute-api.sa-east-1.amazonaws.com/prd";

// URL_BASE_FISCAL removida — fiscal agora é roteado via proxy na API Core (/fiscal/*)

//const URL_INTEGRACOES_BASE = "http://localhost:3000/prd";
// const URL_INTEGRACOES_BASE = "https://j8hr02kzb7.execute-api.sa-east-1.amazonaws.com/prd";

// variavel utilizada para indicar a pasta de gravação das imagens no s3
export const ambiente = "prd"
//export const ambiente = "dev"

// export const urlBase = { url: URL_BASE, method: "GET" };
export const urlBaseCore = { url: URL_BASE_CORE, method: "GET" };
export const urlBasePedidos = { url: URL_BASE_PEDIDOS, method: "GET" };
export const urlBaseProjetos = { url: URL_BASE_PROJETOS, method: "GET" };


export const postCampanha = { url: URL_BASE_CORE + "/campanhas", method: "POST" };
export const putCampanha = { url: URL_BASE_CORE + "/campanhas/{id}", method: "PUT" };
export const getCampanhaPrevia = { url: URL_BASE_CORE + "/campanhas/previa/{campanhaid}", method: "GET" };

// Endpoints para painel de mensagens
// export const postMensagens = { url: URL_BASE_CORE + "/campanhas/mensagens", method: "POST" }; // nao mais utilizado pois a tela esta escondida enviarmensagensclientes
export const postMensagens = { url: URL_BASE_CORE + "/mensagens/criar-mensagem", method: "POST" }; // nao mais utilizado pois a tela esta escondida enviarmensagensclientes

export const getMensagensEmpresa = { url: URL_BASE_CORE + "/mensagens/empresa/{empresaid}", method: "GET" };
export const getEstatisticasMensagens = { url: URL_BASE_CORE + "/mensagens/estatisticas/empresa/{empresaid}", method: "GET" };
export const deletarMensagem = { url: URL_BASE_CORE + "/mensagens/{id}", method: "DELETE" };

// Endpoints para dados financeiros
export const getDadosFinanceiros = { url: URL_BASE_CORE + "/empresas/{id}/dados-financeiros", method: "GET" };

// Endpoints para pagamento de mensagens
export const pagamentoMensagens = { url: URL_BASE_CORE + "/empresas/{id}/pagamento-mensagens", method: "POST" };

// ========================================
// AUTENTICAÇÃO E USUÁRIOS
// ========================================
export const autenticado = { url: URL_BASE_AUTENTICACAO + "/autenticacao/autenticado", method: "POST" };
export const logar = { url: URL_BASE_AUTENTICACAO + "/autenticacao/{cpf}", method: "POST" };
export const confirmarLogin = { url: URL_BASE_AUTENTICACAO + "/autenticacao/{cpf}/otp", method: "POST" };
export const confirmarLoginPin = { url: URL_BASE_AUTENTICACAO + "/autenticacao/{cpf}/pin", method: "POST" };
export const enviarSms = { url: URL_BASE_AUTENTICACAO + "/autenticacao/{cpf}/sms", method: "POST" };
export const enviarEmail = { url: URL_BASE_AUTENTICACAO + "/autenticacao/{cpf}/email", method: "POST" };
export const deslogar = { url: URL_BASE_AUTENTICACAO + "/autenticacao/logout", method: "POST" };
// export const verificaLogin = { url: URL_BASE + "/echoLogado", method: "GET" };

export const cadastraEquipe = { url: URL_BASE_AUTENTICACAO + "/usuarios", method: "POST" };
export const usuariosAlterarPin = { url: URL_BASE_AUTENTICACAO + "/usuarios/{pk}/pin", method: "POST" };
export const usuariosAlterarAcesso = { url: URL_BASE_AUTENTICACAO + "/usuarios/{pk}/acessos", method: "PUT" };
export const listaEquipe = { url: URL_BASE_AUTENTICACAO + "/usuarios", method: "GET" };
export const listaEquipePorPerfil = { url: URL_BASE_AUTENTICACAO + "/usuarios/perfil/{perfil}", method: "GET" };
export const alteraEquipe = { url: URL_BASE_AUTENTICACAO + "/usuarios/{cpf}", method: "PUT" };
export const resetSenhaUsuario = { url: URL_BASE_AUTENTICACAO + "/usuarios/{cpf}", method: "PUT" };
export const excluiUsuario = { url: URL_BASE_AUTENTICACAO + "/usuarios/{cpf}", method: "DELETE" };
export const usuarioExcluir = { url: URL_BASE_AUTENTICACAO + "/usuarios/{id}/cadastro", method: "DELETE" };

// ========================================
// ONBOARDING
// ========================================
export const usuarioCadastrar = { url: URL_BASE_ONBOARDING + "/usuarios/{id}/cadastro", method: "POST" };

// Onboarding Setup (checklist de configuração inicial)
export const onboardingBuscar = { url: URL_BASE_CORE + "/onboarding/{empresa_id}", method: "GET" };
export const onboardingIniciar = { url: URL_BASE_CORE + "/onboarding/{empresa_id}/iniciar", method: "POST" };
export const onboardingAtualizarEtapa = { url: URL_BASE_CORE + "/onboarding/{empresa_id}/etapa", method: "PATCH" };
export const onboardingStatus = { url: URL_BASE_CORE + "/onboarding/{empresa_id}/status", method: "GET" };

// ========================================
// EMPRESAS
// ========================================

// Configurações da empresa - Modulo Core
export const empresaCarregar = { url: URL_BASE_CORE + "/empresas/{id}", method: "GET" };
export const empresaAlterar = { url: URL_BASE_CORE + "/empresas/{id}", method: "PUT" };
export const empresaDeliveryFechadoAlterar = { url: URL_BASE_CORE + "/empresas/{id}?tipo=deliveryfechado", method: "PUT" };
export const empresaConfiguracoesCarregar = { url: URL_BASE_CORE + "/configuracoes-empresas/{id}/configuracoes", method: "GET" }; // generico, usado para carregar configuracoes
export const carregaAssinatura = { url: URL_BASE_CORE + "/assinatura/{id}", method: "GET" };
export const getPlanos = { url: URL_BASE_CORE + "/planos", method: "GET" };
export const pagamentoMensalidade = { url: URL_BASE_CORE + "/empresas/{id}/pagamento", method: "POST" };
export const consultaPagamentoMensalidade = { url: URL_BASE_CORE + "/empresas/{id}/pagamento", method: "GET" };

// Configurações da empresa - Modulo Pedidos
export const empresaConfiguracoesAlterar = { url: URL_BASE_PEDIDOS + "/configuracoes-empresas/{id}", method: "PUT" }; // generico, usado para alterar configuracoes pela querystring
export const ordernarItemFormaPagamentoEmpresa = { url: URL_BASE_PEDIDOS + "/configuracoes-empresas/{id}/formapagamento", method: "PATCH" };
export const removerFormaPagamentoEmpresa = { url: URL_BASE_PEDIDOS + "/configuracoes-empresas/{id}/formapagamento", method: "DELETE" };
export const ordernarItemHorariosEmpresa = { url: URL_BASE_PEDIDOS + "/configuracoes-empresas/{id}/horarios", method: "PATCH" };
export const removerHorariosEmpresa = { url: URL_BASE_PEDIDOS + "/configuracoes-empresas/{id}/horarios", method: "DELETE" };
export const alterarTipoConfiguracoesEntregaEmpresa = { url: URL_BASE_PEDIDOS + "/configuracoes-empresas/{id}/alterar-tipo-entrega", method: "PATCH" };
export const ordernarItemConfiguracoesEntregaEmpresa = { url: URL_BASE_PEDIDOS + "/configuracoes-empresas/{id}/configuracoes-entrega", method: "PATCH" };
export const removerConfiguracoesEntregaEmpresa = { url: URL_BASE_PEDIDOS + "/configuracoes-empresas/{id}/configuracoes-entrega", method: "DELETE" };
export const ordernarItemConfiguracoesCupomEmpresa = { url: URL_BASE_PEDIDOS + "/configuracoes-empresas/{id}/configuracoes-cupom", method: "PATCH" };
export const removerConfiguracoesCupomEmpresa = { url: URL_BASE_PEDIDOS + "/configuracoes-empresas/{id}/configuracoes-cupom", method: "DELETE" };
export const removerTagsEnderecoEmpresa = { url: URL_BASE_PEDIDOS + "/configuracoes-empresas/{id}/tagsendereco", method: "DELETE" };

export const alterarCorCatalogoDigital = { url: URL_BASE_PEDIDOS + "/configuracoes-empresas/{id}/alterar-cor-catalogo-digital", method: "PATCH" };

// Configurações da empresa
export const removerStatusEmpresa = { url: URL_BASE_CORE + "/empresas/{id}/status", method: "DELETE" };
export const ordernarStatusEmpresa = { url: URL_BASE_CORE + "/empresas/{id}/status", method: "PATCH" };
export const inserirStatusEmpresa = { url: URL_BASE_CORE + "/empresas/{id}/status", method: "POST" };
export const alterarStatusEmpresa = { url: URL_BASE_CORE + "/empresas/{id}/status", method: "PUT" };

export const removerStatusVendaEmpresa = { url: URL_BASE_CORE + "/ordens/{id}/statusvenda", method: "DELETE" };
export const ordernarStatusVendaEmpresa = { url: URL_BASE_CORE + "/empresas/{id}/statusvenda", method: "PATCH" };
export const inserirStatusVendaEmpresa = { url: URL_BASE_CORE + "/empresas/{id}/statusvenda", method: "POST" };
export const alterarStatusVendaEmpresa = { url: URL_BASE_CORE + "/empresas/{id}/statusvenda", method: "PUT" };

export const removerFormularioCategoriaEmpresa = { url: URL_BASE_CORE + "/empresas/{id}/formulariocategoria", method: "DELETE" };

export const removerItemFormularioEmpresa = { url: URL_BASE_CORE + "/empresas/{id}/formulario", method: "DELETE" };
export const ordernarItemFormularioEmpresa = { url: URL_BASE_CORE + "/empresas/{id}/formulario", method: "PATCH" };
export const inserirItemFormularioEmpresa = { url: URL_BASE_CORE + "/empresas/{id}/formulario", method: "POST" };
export const alterarItemFormularioEmpresa = { url: URL_BASE_CORE + "/empresas/{id}/formulario", method: "PUT" };


// Configuracões da empresa - Modulo Pedidos - Catalogo de produtos
export const removerItemCatalogoProdutosEmpresa = { url: URL_BASE_PEDIDOS + "/produtos/{id}/catalogoprodutos", method: "DELETE" };
export const ordernarItemCatalogoProdutosEmpresa = { url: URL_BASE_PEDIDOS + "/produtos/{id}/catalogoprodutos", method: "PATCH" };
export const inserirItemCatalogoProdutosEmpresa = { url: URL_BASE_PEDIDOS + "/produtos/{id}/catalogoprodutos", method: "POST" };
export const alterarItemCatalogoProdutosEmpresa = { url: URL_BASE_PEDIDOS + "/produtos/{id}/catalogoprodutos", method: "PUT" };

export const alterarProdutosCategoriaEmpresa = { url: URL_BASE_PEDIDOS + "/produtos/{id}", method: "PUT" };
export const removerProdutosCategoriaNovoEmpresa = { url: URL_BASE_PEDIDOS + "/produtos/{id}/produtoscategoria", method: "DELETE" };
export const ordernarItemCategoriaProdutosEmpresa = { url: URL_BASE_PEDIDOS + "/produtos/{id}/produtoscategoria", method: "PATCH" };

// export const uploadCatalogoProdutosEmpresa = { url: URL_BASE_PEDIDOS + "/produtos/{id}/catalogoprodutosupload", method: "POST" };
export const uploadCatalogoProdutosEmpresaIfood = { url: URL_BASE_PEDIDOS + "/produtos/{id}/catalogoprodutosuploadifood", method: "POST" };
export const uploadCatalogoProdutosEmpresaAnotaAi = { url: URL_BASE_PEDIDOS + "/produtos/{id}/catalogoprodutosuploadadanotaai", method: "POST" };
export const uploadCatalogoProdutosEmpresaYooga = { url: URL_BASE_PEDIDOS + "/produtos/{id}/catalogoprodutosuploadyooga", method: "POST" };
export const uploadCatalogoProdutosEmpresaGoomer = { url: URL_BASE_PEDIDOS + "/produtos/{id}/catalogoprodutosuploadgoomer", method: "POST" };
export const uploadCatalogoProdutosEmpresaBrendi = { url: URL_BASE_PEDIDOS + "/produtos/{id}/catalogoprodutosuploadbrendi", method: "POST" };
export const uploadCatalogoProdutosEmpresaEcta = { url: URL_BASE_PEDIDOS + "/produtos/{id}/catalogoprodutosuploadecta", method: "POST" };
export const uploadCatalogoProdutosEmpresaInstaDelivery = { url: URL_BASE_PEDIDOS + "/produtos/{id}/catalogoprodutosuploadinstadelivery", method: "POST" };
export const uploadCatalogoProdutosEmpresaWhatsMenu = { url: URL_BASE_PEDIDOS + "/produtos/{id}/catalogoprodutosuploadwhatsmenu", method: "POST" };
// Importação por IA (Vision)
export const presignedUrlCatalogoIa = { url: URL_BASE_PEDIDOS + "/produtos/{id}/catalogoia/presignedurl", method: "POST" };
export const uploadCatalogoProdutosEmpresaIa = { url: URL_BASE_PEDIDOS + "/produtos/{id}/catalogoprodutosuploadia", method: "POST" };
export const statusJobCatalogoIa = { url: URL_BASE_PEDIDOS + "/produtos/{id}/catalogoia/job/{jobId}", method: "GET" };
export const confirmarCatalogoProdutosEmpresaIa = { url: URL_BASE_PEDIDOS + "/produtos/{id}/catalogoprodutosconfirmaia", method: "POST" };
// export const uploadCatalogoProdutosEmpresaKivoPedidos = { url: URL_BASE_PEDIDOS + "/produtos/{id}/catalogoprodutosuploadkivopedidos", method: "POST" };

// Configuracões da empresa - Modulo Projetos - Catalogo de serviços
export const removerItemCatalogoServicosEmpresa = { url: URL_BASE_PROJETOS + "/servicos/{id}/catalogoservicos", method: "DELETE" };
export const ordernarItemCatalogoServicosEmpresa = { url: URL_BASE_PROJETOS + "/servicos/{id}/catalogoservicos", method: "PATCH" };
export const inserirItemCatalogoServicosEmpresa = { url: URL_BASE_PROJETOS + "/servicos/{id}/catalogoservicos", method: "POST" };
export const alterarItemCatalogoServicosEmpresa = { url: URL_BASE_PROJETOS + "/servicos/{id}/catalogoservicos", method: "PUT" };

export const alterarServicosCategoriaEmpresa = { url: URL_BASE_PROJETOS + "/servicos/{id}", method: "PUT" };
export const removerServicosCategoriaEmpresa = { url: URL_BASE_PROJETOS + "/servicos/{id}/servicoscategoria", method: "DELETE" };



export const buscarEndereco = { url: URL_BASE_CORE + "/empresas/{id}/endereco", method: "GET" };
export const buscarEnderecoTaxa = { url: URL_BASE_CORE + "/empresas/{id}/endereco/{endereco}", method: "GET" };
export const buscarPlaces = { url: URL_BASE_CORE + "/empresas/{id}/places/{endereco}", method: "GET" };
export const buscarPlaceDetails = { url: URL_BASE_CORE + "/empresas/{id}/places-details/{placeId}", method: "GET" };

// Endpoints de endereço sem empresa (para uso geral)
export const buscarPlacesSimples = { url: URL_BASE_CORE + "/endereco/{endereco}", method: "GET" };
export const buscarPlaceDetailsSimples = { url: URL_BASE_CORE + "/endereco/detalhes/{placeid}", method: "GET" };

// ========================================
// VENDAS
// ========================================
export const incluirVenda = { url: URL_BASE_PROJETOS + "/vendas", method: "POST" };
export const alterarStatusVenda = { url: URL_BASE_PROJETOS + "/vendas/{id}", method: "PATCH" };
export const finalizarVenda = { url: URL_BASE_PROJETOS + "/vendas/{id}", method: "PUT" };
export const vendaRegistrarAnotacao = { url: URL_BASE_PROJETOS + "/vendas/{pk}/anotacoes", method: "POST" };
export const removerArquivoVenda = { url: URL_BASE_PROJETOS + "/vendas/{id}/arquivo", method: "DELETE" };
export const vendaRegistrarArquivo = { url: URL_BASE_PROJETOS + "/vendas/{id}/arquivo", method: "POST" };
export const vendaGerarOrcamento = { url: URL_BASE_PROJETOS + "/vendas/{id}/orcamento", method: "GET" };
export const removerAnotacaoVenda = { url: URL_BASE_PROJETOS + "/vendas/{id}?anotacao={anotacao}", method: "PUT" };

export const removerVendasItemServicosEmpresa = { url: URL_BASE_PROJETOS + "/vendas/{id}/servicos", method: "DELETE" };
export const ordernarVendasItemServicosEmpresa = { url: URL_BASE_PROJETOS + "/vendas/{id}/servicos", method: "PATCH" };
export const inserirVendasItemServicosEmpresa = { url: URL_BASE_PROJETOS + "/vendas/{id}/servicos", method: "POST" };
export const alterarVendasItemServicosEmpresa = { url: URL_BASE_PROJETOS + "/vendas/{id}/servicos", method: "PUT" };

export const removerVendasItemProdutosEmpresa = { url: URL_BASE_PROJETOS + "/vendas/{id}/produtos", method: "DELETE" };
export const ordernarVendasItemProdutosEmpresa = { url: URL_BASE_PROJETOS + "/vendas/{id}/produtos", method: "PATCH" };
export const inserirVendasItemProdutosEmpresa = { url: URL_BASE_PROJETOS + "/vendas/{id}/produtos", method: "POST" };
export const alterarVendasItemProdutosEmpresa = { url: URL_BASE_PROJETOS + "/vendas/{id}/produtos", method: "PUT" };

// ========================================
// BALCÃO
// ========================================
export const abrirBalcao = { url: URL_BASE_PEDIDOS + "/balcao/{id}", method: "POST" };
export const salvarBalcao = { url: URL_BASE_PEDIDOS + "/balcao/{id}", method: "PUT" };
export const alterarBalcao = { url: URL_BASE_PEDIDOS + "/balcao/{id}/alterar", method: "PUT" };
export const fecharBalcao = { url: URL_BASE_PEDIDOS + "/balcao/{id}", method: "PATCH" };
export const emitirNfceBalcao = { url: URL_BASE_PEDIDOS + "/balcao/{id}/nfce", method: "POST" };

// ========================================
// TOTEM (Auto-atendimento)
// ========================================
export const abrirTotem = { url: URL_BASE_PEDIDOS + "/totem/{id}", method: "POST" };
export const salvarTotem = { url: URL_BASE_PEDIDOS + "/totem/{id}", method: "PUT" };
export const alterarTotem = { url: URL_BASE_PEDIDOS + "/totem/{id}/alterar", method: "PUT" };
export const fecharTotem = { url: URL_BASE_PEDIDOS + "/totem/{id}", method: "PATCH" };
export const listarTotemAbertos = { url: URL_BASE_PEDIDOS + "/totem/listaabertas", method: "GET" };
export const salvarAvaliacaoTotem = { url: URL_BASE_PEDIDOS + "/totem/{id}/avaliacao", method: "POST" };
export const enviarCupomTotemEmail = { url: URL_BASE_PEDIDOS + "/totem/{id}/email", method: "POST" };

// ========================================
// MESAS
// ========================================
export const abrirMesa = { url: URL_BASE_PEDIDOS + "/v2/mesas/{id}", method: "POST" };
export const transferirMesa = { url: URL_BASE_PEDIDOS + "/v2/mesas/{id}/transferir", method: "POST" };
export const enviarMesa = { url: URL_BASE_PEDIDOS + "/v2/mesas/{id}", method: "PUT" };
export const alterarMesa = { url: URL_BASE_PEDIDOS + "/v2/mesas/{id}/alterar", method: "PUT" };
export const fecharMesa = { url: URL_BASE_PEDIDOS + "/v2/mesas/{id}", method: "PATCH" };
export const emitirNfceMesa = { url: URL_BASE_PEDIDOS + "/v2/mesas/{id}/nfce", method: "POST" };

// ========================================
// CUPOM
// ========================================
export const mesaGerarCupom = { url: URL_BASE_PEDIDOS + "/cupom/{id}/mesa", method: "GET" };
export const projetoGerarCupom = { url: URL_BASE_PEDIDOS + "/cupom/{id}/html", method: "GET" };
export const projetoGerarCupomParcial = { url: URL_BASE_PEDIDOS + "/cupom/{id}/parcial", method: "GET" };
export const projetoGerarCupomPdf = { url: URL_BASE_PEDIDOS + "/cupom/{id}/pdf", method: "GET" };

// ========================================
// ORDENS
// ========================================
export const incluirProjeto = { url: URL_BASE_CORE + "/ordens", method: "POST" };
export const alterarProjeto = { url: URL_BASE_CORE + "/ordens", method: "PUT" };
export const alterarStatusProjeto = { url: URL_BASE_CORE + "/ordens/{id}", method: "PATCH" };
export const finalizarProjeto = { url: URL_BASE_CORE + "/ordens/{id}", method: "PUT" };
export const encerrarTodosPedidos = { url: URL_BASE_CORE + "/ordens/painel/encerrartodos", method: "PUT" };
export const excluirProjeto = { url: URL_BASE_CORE + "/ordens/{id}", method: "DELETE" };
export const emitirNfceOrdem = { url: URL_BASE_CORE + "/ordens/{id}/nfce", method: "POST" };
export const reabrirProjeto = { url: URL_BASE_CORE + "/ordens/{id}?status=ativo", method: "PUT" };
export const projetoLista = { url: URL_BASE_CORE + "/ordens/loja/{loja}", method: "GET" };

// Projeto - Anotações e responsáveis
export const projetoRegistrarAnotacao = { url: URL_BASE_CORE + "/ordens/{pk}/anotacoes", method: "POST" };
export const projetoRegistrarResponsavel = { url: URL_BASE_CORE + "/ordens/{pk}/responsavel", method: "POST" };
export const projetoRegistrarInformacao = { url: URL_BASE_CORE + "/ordens/{pk}/informacao", method: "POST" };
export const removerAnotacaoProjeto = { url: URL_BASE_CORE + "/ordens/{id}?anotacao={anotacao}", method: "PUT" };
export const removerResponsavelProjeto = { url: URL_BASE_CORE + "/ordens/{id}?responsavel={responsavel}", method: "PUT" };

// Projeto - Arquivos e fotos
export const removerArquivoDetalheProjeto = { url: URL_BASE_CORE + "/ordens/{id}/arquivodetalhe", method: "DELETE" };
export const projetoDetalheRegistrarArquivo = { url: URL_BASE_CORE + "/ordens/{id}/arquivodetalhe", method: "POST" };
export const removerFotoProjeto = { url: URL_BASE_CORE + "/ordens/{id}/photo", method: "DELETE" };
export const removerArquivoProjeto = { url: URL_BASE_CORE + "/ordens/{id}/arquivo", method: "DELETE" };

// Projeto - Serviços e produtos
export const removerProjetosItemServicosEmpresa = { url: URL_BASE_CORE + "/ordens/{id}/servicos", method: "DELETE" };
export const ordernarProjetosItemServicosEmpresa = { url: URL_BASE_CORE + "/ordens/{id}/servicos", method: "PATCH" };
export const inserirProjetosItemServicosEmpresa = { url: URL_BASE_CORE + "/ordens/{id}/servicos", method: "POST" };
export const alterarProjetosItemServicosEmpresa = { url: URL_BASE_CORE + "/ordens/{id}/servicos", method: "PUT" };

export const removerProjetosItemProdutosEmpresa = { url: URL_BASE_CORE + "/ordens/{id}/produtos", method: "DELETE" };
export const ordernarProjetosItemProdutosEmpresa = { url: URL_BASE_CORE + "/ordens/{id}/produtos", method: "PATCH" };
export const inserirProjetosItemProdutosEmpresa = { url: URL_BASE_CORE + "/ordens/{id}/produtos", method: "POST" };
export const alterarProjetosItemProdutosEmpresa = { url: URL_BASE_CORE + "/ordens/{id}/produtos", method: "PUT" };
export const alterarOrdemProdutos = { url: URL_BASE_CORE + "/ordens/{id}/alterar", method: "PUT" };

// Projeto - Relatórios e cupons - usado no projeto para acompanhamento
export const projetoGerarAcompanhamento = { url: URL_BASE_PROJETOS + "/relatorios/{id}/pdf", method: "GET" };

// Projeto - Mensagens
export const enviarMensagemCliente = { url: URL_BASE_CORE + "/ordens/{id}", method: "POST" };
export const listarMensagensCliente = { url: URL_BASE_CORE + "/notificacoes/{id}", method: "GET" };
export const removerNotificacao = { url: URL_BASE_CORE + "/notificacoes/{id}", method: "PUT" };

// Projeto - Status de impressão
export const alterarStatusImprimir = { url: URL_BASE_CORE + "/ordens/status-imprimir-false", method: "PATCH" };

// ========================================
// OPERAÇÕES
// ========================================
export const operacaoChamarMotorista = { url: URL_BASE_CORE + "/operacoes/{pk}", method: "POST" };
export const operacaoRegistrarAnotacao = { url: URL_BASE_CORE + "/operacoes/{pk}/anotacoes", method: "POST" };
export const encerrarOperacao = { url: URL_BASE_CORE + "/operacoes/{id}", method: "PUT" };
export const incluirFotoOperacao = { url: URL_BASE_CORE + "/operacoes", method: "PATCH" };
export const removerFotoOperacao = { url: URL_BASE_CORE + "/operacoes/{id}/photo", method: "DELETE" };
export const incluiNotaFiscal = { url: URL_BASE_CORE + "/operacoes/{id}/notas", method: "POST" };
export const listaFotosProjeto = { url: URL_BASE_CORE + "/operacoes/{projeto}/projeto/", method: "GET" };
export const removerAnotacaoOperacao = { url: URL_BASE_CORE + "/operacoes/{id}?anotacao={anotacao}", method: "PUT" };
export const operacaoProjetoCarregar = { url: URL_BASE_CORE + "/operacoes/projeto/{projetoid}", method: "GET" };

export const carregaFormulario = { url: URL_BASE_CORE + "/operacoes/{id}/formulario", method: "GET" };
export const salvarFormulario = { url: URL_BASE_CORE + "/operacoes/{id}/formulario", method: "POST" };
export const registrarFoto = { url: URL_BASE_CORE + "/operacoes/{id}/formulariofoto", method: "POST" };
export const removerFotoFormulario = { url: URL_BASE_CORE + "/operacoes/{id}/formulariofoto", method: "DELETE" };

// ========================================
// AGENDAMENTOS
// ========================================
export const incluirAgendamento = { url: URL_BASE_CORE + "/agendamentos", method: "POST" };
export const finalizarAgendamento = { url: URL_BASE_CORE + "/agendamentos/{id}", method: "PUT" };
export const agendamentoRegistrarAnotacao = { url: URL_BASE_CORE + "/agendamentos/{pk}/anotacoes", method: "POST" };
export const removerAnotacaoAgendamento = { url: URL_BASE_CORE + "/agendamentos/{id}?anotacao={anotacao}", method: "PUT" };
export const agendamentoProjetoCarregar = { url: URL_BASE_CORE + "/agendamentos/projeto/{projetoid}", method: "GET" };
export const projetoCarregar = { url: URL_BASE_CORE + "/agendamentos/{id}/projeto", method: "GET" };

// ========================================
// CAIXA GERAL
// ========================================
export const apiPedidosCaixaGeralLancamentosGET = { url: URL_BASE_PEDIDOS + "/caixas/{id}/caixageral/lancamentos", method: "GET" };
export const apiPedidosCaixasGET = { url: URL_BASE_PEDIDOS + "/caixas/{id}", method: "GET" };
export const apiPedidosCaixasPOST = { url: URL_BASE_PEDIDOS + "/caixas/{id}", method: "POST" };
export const apiPedidosCaixasLancamentoPOST = { url: URL_BASE_PEDIDOS + "/caixas/{id}/lancamento", method: "POST" };
export const apiPedidosCaixasPUT = { url: URL_BASE_PEDIDOS + "/caixas/{id}", method: "PUT" };
export const apiPedidosCaixasFechamentoGET = { url: URL_BASE_PEDIDOS + "/caixas/{id}/fechamento", method: "GET" };

// ========================================
// INTEGRAÇÕES - IFOOD
// ========================================
export const apiIfoodAouthUserCode = { url: URL_BASE_PEDIDOS + "/ifood/oauth/userCode", method: "POST" };
export const apiIfoodAouthUserToken = { url: URL_BASE_PEDIDOS + "/ifood/oauth/token", method: "POST" };
export const apiIfoodMerchants = { url: URL_BASE_PEDIDOS + "/ifood/{id}/merchants", method: "GET" };
export const apiIfoodMerchantsDetails = { url: URL_BASE_PEDIDOS + "/ifood/{id}/merchants/{merchantId}", method: "GET" };
export const apiIfoodMerchantsStatus = { url: URL_BASE_PEDIDOS + "/ifood/{id}/merchants/{merchantId}/status", method: "GET" };
export const apiIfoodMerchantsInterruptions = { url: URL_BASE_PEDIDOS + "/ifood/{id}/merchants/{merchantId}/interruptions", method: "GET" };
export const apiIfoodPostMerchantsInterruptions = { url: URL_BASE_PEDIDOS + "/ifood/{id}/merchants/{merchantId}/interruptions", method: "POST" };
export const apiIfoodDeleteMerchantsInterruptions = { url: URL_BASE_PEDIDOS + "/ifood/{id}/merchants/{merchantId}/interruptions/{interruptionId}", method: "DELETE" };
export const apiIfoodMerchantsOpeningHours = { url: URL_BASE_PEDIDOS + "/ifood/{id}/merchants/{merchantId}/opening-hours", method: "GET" };
export const apiIfoodPutMerchantsOpeningHours = { url: URL_BASE_PEDIDOS + "/ifood/{id}/merchants/{merchantId}/opening-hours", method: "PUT" };
export const apiIfoodEvents = { url: URL_BASE_PEDIDOS + "/ifood/{id}/events", method: "GET" };
export const apiIfoodDispatch = { url: URL_BASE_PEDIDOS + "/ifood/{id}/order/{orderId}/dispatch", method: "POST" };
export const apiIfoodReadToPickup = { url: URL_BASE_PEDIDOS + "/ifood/{id}/order/{orderId}/readyToPickup", method: "POST" };
export const apiIfoodConfirm = { url: URL_BASE_PEDIDOS + "/ifood/{id}/order/{orderId}/confirm", method: "POST" };
export const apiIfoodCancellationReasons = { url: URL_BASE_PEDIDOS + "/ifood/{id}/order/{orderId}/cancellationReasons", method: "GET" };
export const apiIfoodRequestCancellation = { url: URL_BASE_PEDIDOS + "/ifood/{id}/order/{orderId}/requestCancellation", method: "POST" };
export const apiIfoodDisputeAccept = { url: URL_BASE_PEDIDOS + "/ifood/{id}/order/disputes/{disputeId}/accept", method: "POST" };
export const apiIfoodDisputeReject = { url: URL_BASE_PEDIDOS + "/ifood/{id}/order/disputes/{disputeId}/reject", method: "POST" };

// ========================================
// INTEGRAÇÕES - 99FOOD
// ========================================
export const api99FoodAuthorizationUrl = { url: URL_BASE_PEDIDOS + "/99food/{id}/authorizationUrl", method: "POST" };
export const api99FoodToken = { url: URL_BASE_PEDIDOS + "/99food/{id}/token", method: "POST" };
export const api99FoodShops = { url: URL_BASE_PEDIDOS + "/99food/{id}/shops", method: "GET" };
export const api99FoodDiagnostic = { url: URL_BASE_PEDIDOS + "/99food/{id}/diagnostic", method: "GET" };
export const api99FoodShopDetail = { url: URL_BASE_PEDIDOS + "/99food/{id}/shop/detail", method: "GET" };
export const api99FoodConfirm = { url: URL_BASE_PEDIDOS + "/99food/{id}/order/confirm", method: "POST" };
export const api99FoodCancel = { url: URL_BASE_PEDIDOS + "/99food/{id}/order/cancel", method: "POST" };
export const api99FoodReady = { url: URL_BASE_PEDIDOS + "/99food/{id}/order/ready", method: "GET" };
export const api99FoodDelivered = { url: URL_BASE_PEDIDOS + "/99food/{id}/order/delivered", method: "GET" };
export const api99FoodSetStatus = { url: URL_BASE_PEDIDOS + "/99food/{id}/shop/setStatus", method: "POST" };
export const api99FoodSetConfirmMethod = { url: URL_BASE_PEDIDOS + "/99food/{id}/shop/setconfirmmethod", method: "POST" };

// ========================================
// INTEGRAÇÕES - MERCADO PAGO
// ========================================
export const apiMercadoPagoTerminals = { url: URL_BASE_PEDIDOS + "/mercadopago/terminals", method: "GET" };
export const apiMercadoPagoOperationMode = { url: URL_BASE_PEDIDOS + "/mercadopago/terminals", method: "PATCH" };
export const apiMercadoPagoOperationCriarPagamento = { url: URL_BASE_PEDIDOS + "/ordens/{id}/empresa/{idEmpresa}/mercadopago/orders", method: "POST" };
export const apiMercadoPagoConfirmacaoPagamento = { url: URL_BASE_PEDIDOS + "/ordens/{id}/orders", method: "GET" };
export const apiMercadoPagoCancelamentoPagamento = { url: URL_BASE_PEDIDOS + "/ordens/{id}/mercadopago/orders/{orderId}", method: "DELETE" };
export const apiMercadoPagoCriarConfiguracao = { url: URL_BASE_PEDIDOS + "/empresas/{id}/configuracao/mercadopago", method: "POST" };
export const apiMercadoPagoBuscarConfiguracao = { url: URL_BASE_PEDIDOS + "/empresas/{id}/configuracao/mercadopago", method: "GET" };

// ========================================
// INTEGRAÇÕES - MARKETING & CONVERSÕES (Meta Pixel + CAPI + GA4)
// ========================================
export const apiMarketingBuscarConfiguracao = { url: URL_BASE_CORE + "/empresas/{id}/configuracao/marketing", method: "GET" };
export const apiMarketingSalvarConfiguracao = { url: URL_BASE_CORE + "/empresas/{id}/configuracao/marketing", method: "POST" };
export const apiMarketingExcluirConfiguracao = { url: URL_BASE_CORE + "/empresas/{id}/configuracao/marketing", method: "DELETE" };
export const apiMarketingTestarConexao = { url: URL_BASE_CORE + "/empresas/{id}/configuracao/marketing/testar", method: "POST" };

// ========================================
// WHATSAPP
// ========================================
export const apiWhatsappWebQrcode = { url: URL_BASE_CORE + "/whatsapp/web/qrcode/{id}", method: "GET" };
export const apiWhatsappWebStart = { url: URL_BASE_CORE + "/whatsapp/web/start/{id}", method: "POST" };
export const apiEmpresaConfiguracaoRoboSalvar = { url: URL_BASE_CORE + "/empresas/{id}/configuracao/robo", method: "POST" };

// ========================================
// OUTROS SERVIÇOS
// ========================================
export const assinaUrl = { url: URL_BASE_CORE + "/assinaUrl", method: "POST" };

// ========================================
// DOMÍNIOS
// ========================================
// Verificar disponibilidade de domínio .br
export const apiDominioCheckBr = { url: URL_BASE_CORE + "/dominios/check-br", method: "GET" };



// ========================================
// FISCAL (NFC-e) — Roteado via proxy na API Core (autenticação padrão por token)
// ========================================

// Certificado Digital
export const fiscalUploadCertificado = { url: URL_BASE_CORE + "/fiscal/certificado/upload", method: "POST" };
export const fiscalConsultarCertificado = { url: URL_BASE_CORE + "/fiscal/certificado/{empresaId}", method: "GET" };
export const fiscalRemoverCertificado = { url: URL_BASE_CORE + "/fiscal/certificado/{empresaId}", method: "DELETE" };

// Configuração Fiscal
export const fiscalSalvarConfiguracao = { url: URL_BASE_CORE + "/fiscal/nfce/config", method: "POST" };
export const fiscalBuscarConfiguracao = { url: URL_BASE_CORE + "/fiscal/nfce/config/{empresaId}", method: "GET" };

// Status SEFAZ
export const fiscalStatusSefaz = { url: URL_BASE_CORE + "/fiscal/nfce/status", method: "POST" };

// Emissão de NFC-e
export const fiscalEmitirNFCe = { url: URL_BASE_CORE + "/fiscal/nfce/emitir", method: "POST" };

// Consultas de NFC-e
export const fiscalConsultarNFCe = { url: URL_BASE_CORE + "/fiscal/nfce/consultar", method: "POST" };
export const fiscalListarNFCe = { url: URL_BASE_CORE + "/fiscal/nfce/empresa/{empresaId}", method: "GET" };
export const fiscalBuscarNFCePorChave = { url: URL_BASE_CORE + "/fiscal/nfce/chave/{chave}", method: "GET" };
export const fiscalBuscarNFCePorId = { url: URL_BASE_CORE + "/fiscal/nfce/{nfceId}", method: "GET" };
export const fiscalBuscarNFCePorVenda = { url: URL_BASE_CORE + "/fiscal/nfce/venda/{vendaId}", method: "GET" };

// Relatório Fiscal
export const fiscalRelatorioNFCe = { url: URL_BASE_CORE + "/fiscal/nfce/relatorio/{empresaId}", method: "GET" };

// Download XML em lote (ZIP via presigned URL S3)
export const fiscalDownloadXmlNFCe = { url: URL_BASE_CORE + "/fiscal/export/xml/{empresaId}", method: "GET" };

// Cancelamento de NFC-e
export const fiscalCancelarNFCe = { url: URL_BASE_CORE + "/fiscal/nfce/cancelar", method: "POST" };

// Reimpressão de NFC-e
export const fiscalReimprimirNFCe = { url: URL_BASE_CORE + "/fiscal/nfce/reimprimir", method: "POST" };

// Inutilização de Numeração
export const fiscalInutilizarNumeracao = { url: URL_BASE_CORE + "/fiscal/nfce/inutilizar", method: "POST" };

// Categorias Fiscais
export const fiscalListarCategorias = { url: URL_BASE_CORE + "/fiscal/v1/categorias?empresaId={empresaId}", method: "GET" };
export const fiscalCriarCategoria = { url: URL_BASE_CORE + "/fiscal/v1/categorias", method: "POST" };
export const fiscalBuscarCategoria = { url: URL_BASE_CORE + "/fiscal/v1/categorias/{id}?empresaId={empresaId}", method: "GET" };
export const fiscalAtualizarCategoria = { url: URL_BASE_CORE + "/fiscal/v1/categorias/{id}", method: "PUT" };
export const fiscalDesativarCategoria = { url: URL_BASE_CORE + "/fiscal/v1/categorias/{id}?empresaId={empresaId}", method: "DELETE" };
export const fiscalSeedCategorias = { url: URL_BASE_CORE + "/fiscal/v1/categorias/seed", method: "POST" };


// ========================================
// FINANCEIRO
// ========================================
// export const reportsBuscar = { url: URL_BASE_CORE + "/reports", method: "GET" };
export const incluirFinanceiro = { url: URL_BASE_CORE + "/financeiro", method: "POST" };
export const baixarFinanceiro = { url: URL_BASE_CORE + "/financeiro/{id}", method: "PATCH" };
export const alterarFinanceiro = { url: URL_BASE_CORE + "/financeiro/{id}", method: "PUT" };
export const excluirFinanceiro = { url: URL_BASE_CORE + "/financeiro/{id}", method: "DELETE" };
export const removerFinanceiroCategoriaEmpresa = { url: URL_BASE_CORE + "/empresas/{id}/financeirocategoria", method: "DELETE" };

// // ========================================
// // WHATSAPP - DESCONTINUADO
// // ========================================
// export const enviarMensagemWhatsapp = { url: URL_BASE + "/whatsapp", method: "POST" };
// export const enviarArquivoWhatsapp = { url: URL_BASE + "/whatsapp/arquivo", method: "POST" };
// export const enviarAudioWhatsapp = { url: URL_BASE + "/whatsapp/audio", method: "POST" };
// export const habilitarMensagemWhatsapp = { url: URL_BASE + "/whatsapp/habilitar", method: "POST" };
// export const carregarMensagemWhatsapp = { url: URL_BASE + "/whatsapp/{id}/loja/{loja}", method: "GET" };
// export const carregarEmpresaMensagemWhatsapp = { url: URL_BASE + "/whatsapp/{id}/empresa", method: "GET" };


// // ========================================
// // DESCONTINUADO
// // ========================================
// export const enviarNotificacao = { url: URL_BASE + "/notificacao", method: "POST" };
// export const cadastraConvidado = { url: URL_BASE + "/convidados", method: "POST" };
// export const excluiConvidado = { url: URL_BASE + "/convidados/{pk}/{sk}", method: "DELETE" };
// export const listaConvidados = { url: URL_BASE + "/convidados", method: "GET" };
// export const enviarArquivoPortfolio = { url: URL_BASE + "/portfolio", method: "POST" };
// export const alterarDetaquePortfolio = { url: URL_BASE + "/portfolio/{id}", method: "PUT" };
// export const removerArquivoPortfolioCategoria = { url: URL_BASE + "/portfolio/{id}", method: "DELETE" };
// export const removerArquivoPortfolioGaleria = { url: URL_BASE + "/portfolio/{id}/galeria", method: "DELETE" };
// export const incluirLembrete = { url: URL_BASE + "/lembretes", method: "POST" };
// export const lembretesCarregar = { url: URL_BASE + "/lembretes/{id}", method: "GET" };
// export const removerLembrete = { url: URL_BASE + "/lembretes/{id}", method: "DELETE" };
// export const onboarding_all = { url: URL_BASE + "/onBoarding/v1?onBoarding=1", method: "GET" };


// ========================================
// FUNÇÕES UTILITÁRIAS
// ========================================
export async function getJSONObject(url: string) {
  const response = await fetch(url);
  const myJson = await response.json();
  return myJson;
}

// ========================================
// FUNÇÃO MELHORADA COM MELHORES PRÁTICAS
// ========================================

// Tipos flexíveis para headers (compatibilidade legacy)
type LegacyHeaders = Array<[string, string | null]>;
type ModernHeaders = Record<string, string> | Headers;

interface RequestOptions extends Omit<RequestInit, 'headers'> {
  timeout?: number;
  retries?: number;
  headers?: LegacyHeaders | ModernHeaders | HeadersInit;
}

interface ApiResponse {
  status: number;
  message?: string;
  [key: string]: any;
}

interface ApiError extends ApiResponse {
  originalError?: string;
}

export async function requestService(
  url: string,
  config: RequestOptions = {},
  history: any,
  callbackSuccess: (response: ApiResponse) => void,
  callbackError: (error: ApiError) => void,
  redirectLogin: boolean = true,
  getStatus: boolean = false
): Promise<void> {

  // Validação de parâmetros
  if (!url || typeof url !== 'string') {
    callbackError({
      status: 0,
      message: "URL inválida ou não fornecida"
    });
    return;
  }

  if (!callbackSuccess || !callbackError) {
    console.error("Callbacks são obrigatórios");
    return;
  }

  // Configuração padrão com melhores práticas
  const defaultTimeout = config.timeout || 30000; // 30 segundos
  const maxRetries = config.retries || 0;

  const abortController = new AbortController();
  const timeoutId = setTimeout(() => {
    abortController.abort();
  }, defaultTimeout);

  // Headers padrão organizados
  const token = localStorage.getItem("token");
  const defaultHeaders: Record<string, string> = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    ...(token && { 'token': token }),
  };

  // Processar headers de forma flexível (legacy + modern)
  let processedHeaders: Record<string, string> = {};
  if (config.headers) {
    if (Array.isArray(config.headers)) {
      // Formato legacy: array de arrays
      config.headers.forEach((header) => {
        if (Array.isArray(header) && header.length >= 2) {
          const [key, value] = header;
          if (key && value != null && value !== '') {
            processedHeaders[key] = String(value);
          }
        }
      });
    } else if (config.headers instanceof Headers) {
      // Headers API nativa
      config.headers.forEach((value, key) => {
        if (key && value) {
          processedHeaders[key] = value;
        }
      });
    } else if (typeof config.headers === 'object') {
      // Objeto simples
      Object.entries(config.headers).forEach(([key, value]) => {
        if (key && value != null && value !== '') {
          processedHeaders[key] = String(value);
        }
      });
    }
  }

  // Configuração final da requisição
  const requestConfig: RequestInit = {
    ...config,
    signal: abortController.signal,
    credentials: config.credentials || 'include',
    headers: {
      ...defaultHeaders,
      ...processedHeaders,
    },
  };

  // Função para fazer a requisição com retry
  const makeRequest = async (attempt: number = 0): Promise<void> => {
    try {
      console.log(`[API] ${config.method || 'GET'} ${url} - Tentativa ${attempt + 1}`);

      const response = await fetch(url, requestConfig);
      clearTimeout(timeoutId);

      if (!response) {
        throw new Error("Resposta vazia do servidor");
      }

      await handleResponse(response);

    } catch (error: any) {
      clearTimeout(timeoutId);

      // Retry logic para erros de rede (exceto CORS e 4xx)
      if (shouldRetry(error, attempt, maxRetries)) {
        console.log(`[API] Tentando novamente... (${attempt + 1}/${maxRetries + 1})`);
        await new Promise(resolve => setTimeout(resolve, 1000 * (attempt + 1))); // Backoff exponencial
        return makeRequest(attempt + 1);
      }

      handleError(error);
    }
  };

  // Processa resposta HTTP
  const handleResponse = async (response: Response): Promise<void> => {
    const isSuccess = response.status >= 200 && response.status < 300;

    try {
      const data = await response.json();

      if (getStatus) {
        data.status = response.status;
      }

      if (response.status === 401 && redirectLogin) {
        if (history) history.replace("/login");
        callbackError({
          status: response.status,
          message: "Sessão expirada. Faça login novamente.",
          ...data
        });
        return;
      }

      if (isSuccess) {
        console.log(`[API] Sucesso: ${response.status}`, data);
        callbackSuccess(data);
      } else {
        console.warn(`[API] Erro HTTP: ${response.status}`, data);
        callbackError({
          status: response.status,
          message: getHttpErrorMessage(response.status, data.message),
          ...data
        });
      }

    } catch (jsonError) {
      // Resposta não é JSON válido
      const errorMessage = isSuccess
        ? "Erro ao processar resposta do servidor"
        : `Erro ${response.status}: ${response.statusText}`;

      callbackError({
        status: response.status,
        message: errorMessage,
        originalError: "Invalid JSON response"
      });
    }
  };

  // Processa erros de rede/conexão
  const handleError = (error: any): void => {
    console.error("[API] Erro na requisição:", error);

    const apiError: ApiError = {
      status: 0,
      message: getNetworkErrorMessage(error),
      originalError: error.message
    };

    callbackError(apiError);
  };

  // Verifica se deve tentar novamente
  const shouldRetry = (error: any, attempt: number, maxRetries: number): boolean => {
    if (attempt >= maxRetries) return false;
    if (error.name === 'AbortError') return false;
    if (error.message?.includes('CORS')) return false;

    // Retry apenas para erros de rede temporários
    return error.name === 'TypeError' ||
      error.message?.includes('Failed to fetch') ||
      error.message?.includes('Network request failed');
  };

  // Inicia a requisição
  await makeRequest();
}

// ========================================
// FUNÇÕES AUXILIARES
// ========================================

function getHttpErrorMessage(status: number, serverMessage?: string): string {
  if (serverMessage) return serverMessage;

  const statusMessages: Record<number, string> = {
    400: "Dados inválidos. Verifique os campos e tente novamente.",
    401: "Não autorizado. Faça login novamente.",
    403: "Você não tem permissão para esta ação.",
    404: "Recurso não encontrado.",
    409: "Conflito. O recurso já existe ou está em uso.",
    422: "Dados inválidos. Verifique os campos.",
    429: "Muitas tentativas. Aguarde um momento.",
    500: "Erro interno do servidor.",
    502: "Servidor temporariamente indisponível.",
    503: "Serviço temporariamente indisponível.",
    504: "Timeout do servidor. Tente novamente."
  };

  return statusMessages[status] || `Erro ${status}: Tente novamente mais tarde.`;
}

function getNetworkErrorMessage(error: any): string {
  if (error.name === 'AbortError') {
    return "Requisição cancelada por timeout. Tente novamente.";
  }

  if (error.message?.includes('CORS')) {
    return "Erro de conexão. Verifique sua internet e tente novamente.";
  }

  if (error.message?.includes('Failed to fetch') || error.message?.includes('Network request failed')) {
    return "Erro de rede. Verifique sua conexão com a internet.";
  }

  if (error.name === 'TypeError') {
    return "Erro de conexão ou URL inválida.";
  }

  return "Erro de conexão com o servidor.";
}
